import { projectVenueMonthDeclarationSlice } from '../project-venue-month-declarations.slice';

export const clearProjectVenueMonthDeclaration =
  projectVenueMonthDeclarationSlice.actions.clearByMonth;
